<template>
  <div class="bottom">
    <el-tabs v-model="activeName" type="card">
      <template v-for="(item,index) in componentConfig">
        <el-tab-pane v-if="getListPermission(item.compName)" :key="index" :label="item.label" :name="item.compName" />
      </template>
    </el-tabs>
    <component :is="activeName" :key="activeName" @get-merchant-info="$emit('get-merchant-info')" />
  </div>
</template>

<script>
import { generateTitle } from '@/utils/i18n'
import { checkPermission } from '@/utils/directive/permission'

export default {
  name: 'Balance_Trans_Details',
  components: {
    Withdraw_Record: () => import('./WithdrawRecord'),
    Recharge_Record: () => import('./RechargeRecord'),
    Summary_Details: () => import('./SummaryDetails'),
    Transfer_Record: () => import('./TransferRecord'),
    NSDS_Bill: () => import('./NSDSBill')
  },
  data() {
    // tab的配置
    this.tabConfigArr = [
      {
        label: 'recharge_status_1',
        type: 'doing'
      },
      {
        label: 'recharge_status_2',
        type: 'success'
      }, {
        label: 'recharge_status_3',
        type: 'fail'
      }]

    return {
      activeName: 'Summary_Details'
    }
  },
  computed: {
    componentConfig() {
      const arr = [
        { compName: 'Summary_Details', label: this.$t('data.summary_details') },
        { compName: 'Recharge_Record', label: this.$t('data.recharge_record') },
        { compName: 'Withdraw_Record', label: this.$t('data.withdraw_record') },
        { compName: 'NSDS_Bill', label: this.$t('data.nsds_bill') }
      ]
      if (this.$store.getters.isID) {
        arr.push({ compName: 'Transfer_Record', label: this.$t('data.Transfer_Record') })
      }
      return arr
    }
  },
  created() {
    const { activeName } = this.$route.params
    if (activeName) {
      this.activeName = activeName
    }
  },
  methods: {
    generateTitle,
    getListPermission(name) {
      if (name === 'Summary_Details') {
        return checkPermission(['ROLE_AUTH_SETTLEMENT_BALANCE'])
      }
      if (name === 'Recharge_Record') {
        return checkPermission(['ROLE_AUTH_SETTLEMENT_RECHARGE'])
      }
      if (name === 'Withdraw_Record') {
        return checkPermission(['ROLE_AUTH_SETTLEMENT_WITHDRAW'])
      }
      if (name === 'NSDS_Bill' && this.$store.getters.nsdsStatus) {
        return checkPermission(['ROLE_AUTH_SETTLEMENT_BALANCE'])
      }
      if (name === 'Transfer_Record') {
        return checkPermission(['AUTH_CODE_BALANCE'])
      }
      return false
    }
  }
}
</script>

<style scoped>
.bottom{
  margin-top: 40px;
}
</style>
